import React from 'react';
import { usePlatformAdvertisingAgreement } from '../../hooks/usePlatformAdvertisingAgreement';
import './InvertAdvertisingAgreementDocument.css';

export default function InvertAdvertisingAgreementDocument({
    amountUsd,
    screenCount,
    selectedScreenIds,
    showEsignNotice = false,
    showSignatures = true,
    compact = false,
    companyName,
    legalName
}) {
    const { doc, sections, loading, error } = usePlatformAdvertisingAgreement(amountUsd, {
        screenCount,
        selectedScreenIds,
    });

    if (loading) {
        return (
            <article
                className={`invert-ad-agreement-document ${compact ? 'invert-ad-agreement-document--compact' : ''}`}
            >
                <p>Loading agreement…</p>
            </article>
        );
    }

    if (error || !doc) {
        return (
            <article
                className={`invert-ad-agreement-document ${compact ? 'invert-ad-agreement-document--compact' : ''}`}
            >
                <p>Could not load agreement. Please try again later.</p>
            </article>
        );
    }

    return (
        <article
            className={`invert-ad-agreement-document ${compact ? 'invert-ad-agreement-document--compact' : ''}`}
        >
            <header className="invert-ad-agreement-header">
                <h1>{doc.title}</h1>
                <p className="invert-ad-agreement-version">Version {doc.version}</p>
                {doc.amountUsd != null && (
                    <p className="invert-ad-agreement-package">
                        {doc.screenCount > 0 && doc.playsPerScreen != null ? (
                            <>
                                {Number(doc.screenCount).toLocaleString('en-US')} selected screen
                                {doc.screenCount === 1 ? '' : 's'} · {Number(doc.playsPerScreen).toLocaleString('en-US')}{' '}
                                ad plays per screen (180/day × 30 days)
                                {doc.guaranteedPlays != null && (
                                    <>
                                        {' '}
                                        ({Number(doc.guaranteedPlays).toLocaleString('en-US')} plays total minimum)
                                    </>
                                )}
                            </>
                        ) : doc.guaranteedPlays != null ? (
                            <>
                                Guaranteed minimum:{' '}
                                {Number(doc.guaranteedPlays).toLocaleString('en-US')} ad plays (package)
                            </>
                        ) : null}
                        {' · '}
                        Campaign fee: ${Number(doc.amountUsd).toLocaleString('en-US')}
                        {doc.maxReviewHours != null && (
                            <>
                                {' · '}
                                Review within {Number(doc.maxReviewHours)} hours of creative submission
                            </>
                        )}
                    </p>
                )}
            </header>

            {(companyName || legalName) && (
                <p className="invert-ad-agreement-party-line">
                    {companyName && (
                        <>
                            <strong>Company:</strong> {companyName}
                        </>
                    )}
                    {legalName && (
                        <>
                            {companyName ? ' · ' : ''}
                            <strong>Advertiser:</strong> {legalName}
                        </>
                    )}
                </p>
            )}

            <div className="invert-ad-agreement-sections">
                {sections.map((section) => (
                    <section key={section.title} className="invert-ad-agreement-section">
                        <h2>{section.title}</h2>
                        <p>{section.body}</p>
                    </section>
                ))}
            </div>

            {showSignatures && (
                <div className="invert-ad-agreement-signatures">
                    <div className="invert-ad-agreement-signature-block">
                        <p className="invert-ad-agreement-signature-party">INVERT LLC</p>
                        <p className="invert-ad-agreement-signature-by">By:</p>
                        <div className="invert-ad-agreement-signature-line" />
                        <p className="invert-ad-agreement-signature-name">INVERT LLC</p>
                    </div>
                    <div className="invert-ad-agreement-signature-block">
                        <p className="invert-ad-agreement-signature-party">ADVERTISER</p>
                        <p className="invert-ad-agreement-signature-by">By:</p>
                        <div className="invert-ad-agreement-signature-line" />
                        {legalName && (
                            <p className="invert-ad-agreement-signature-name">{legalName}</p>
                        )}
                    </div>
                </div>
            )}

            {showEsignNotice && doc.esignNotice && (
                <p className="invert-ad-agreement-esign">{doc.esignNotice}</p>
            )}
        </article>
    );
}
